module.exports = __webpack_public_path__ + "img/user-count-icon.84699393.png";